import { render, staticRenderFns } from "./ChatWithDoctorView.vue?vue&type=template&id=5495af26"
import script from "./ChatWithDoctorView.vue?vue&type=script&lang=js"
export * from "./ChatWithDoctorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports